import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IFilterView } from '@ncg/data';

@Component({
    selector: 'ncg-product-skeleton',
    template: `
        <article class="product-item__skeleton product-item--skeleton">
            <div class="product-item__skeleton-loading"></div>
            <div class="columns is-multiline is-gapless">
                <div class="column is-relative" [ngClass]="view === 'grid' ? 'is-full' : 'is-2'">
                    <div class="product-item__media-wrapper is-ratio-product-item"></div>
                </div>
                <div class="column" [ngClass]="view === 'grid' ? 'is-full' : 'is-10'">
                    <div class="columns is-mobile is-gapless">
                        <div class="column">
                            <div class="product-item__info">
                                <h3 class="product-item__title--skeleton"></h3>
                                <div class="product-item__details--skeleton"></div>
                                <div class="product-item__details--skeleton"></div>
                            </div>
                        </div>
                        <div class="column is-narrow">
                            <div class="product-pricing--skeleton"></div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSkeletonComponent {
    @Input() view?: IFilterView;
}
